// @core/api/endpoints/booking/list_booking_types.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBookingTypesResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * List booking types
 * Returns all registered booking types, optionally filtered by product.
 */
export async function ListBookingTypes(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    product_id?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListBookingTypesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/booking-types`;
  const requestOptions = options;
  return client.get<ListBookingTypesResponse>(requestPath, { ...requestOptions, params });
}
